import { cn } from "@/components/ui/utils";

type MonoAmountSize = "inherit" | "xs" | "sm" | "lg" | "xl";

interface MonoAmountProps {
  children: React.ReactNode;
  className?: string;
  size?: MonoAmountSize;
}

const sizeClasses: Record<MonoAmountSize, string> = {
  inherit: "",
  xs: "text-sm",
  sm: "text-base",
  lg: "text-section-title",
  xl: "text-h5",
};

/**
 * Renders numeric amounts (currency, quantities) with tabular numerals.
 * Use for all monetary values displayed outside of inputs.
 *
 * Size guide:
 * - inherit: inherit text size from the parent
 * - xs: small table cells, secondary inline amounts
 * - sm (default): table cells, inline amounts
 * - lg: card stat headings
 * - xl: page-level summary headings
 *
 * For larger exceptions, pass an explicit semantic className override.
 */
export function MonoAmount({ children, size = "sm", className }: MonoAmountProps) {
  const resolvedClassName = cn("font-semibold", sizeClasses[size], className);

  return <span className={`${resolvedClassName} text-numeric`}>{children}</span>;
}
